import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useKeyPress(key, onKeyDown, onKeyUp) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] !== key || $[1] !== onKeyDown || $[2] !== onKeyUp) {
    t0 = () => {
      const handleKeyDown = e => {
        if (e.key === key && !e.repeat) {
          onKeyDown?.();
        }
      };
      const handleKeyUp = e_0 => {
        if (e_0.key === key) {
          onKeyUp?.();
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      window.addEventListener("keyup", handleKeyUp);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
        window.removeEventListener("keyup", handleKeyUp);
      };
    };
    t1 = [key, onKeyDown, onKeyUp];
    $[0] = key;
    $[1] = onKeyDown;
    $[2] = onKeyUp;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}
export function useIsKeyPress(key) {
  const $ = _c(2);
  const [isPressed, setIsPressed] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsPressed(true);
    t1 = () => setIsPressed(false);
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useKeyPress(key, t0, t1);
  return isPressed;
}